/*
 * Questionario "Trova il tuo rituale", versione 2 (WebGas, ottobre 2026).
 * Stessi dati e stessa logica della versione di Andrea (quiz-rituale.js, intatta):
 * cambiano impaginazione mobile first, selezione radio/checkbox con pulsante fisso,
 * anteprima sfocata prima dell'email e pagina del risultato.
 * Prezzo, disponibilità, immagine e variante si leggono dallo store; il JSON resta per i testi.
 */
(function () {
  'use strict';

  var root = document.querySelector('.quiz-rituale-v2');
  if (!root) return;
  var dataEl = document.getElementById('QuizRitualeDati');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var S = D.schermate;
  var I = D.ingresso || {};
  var stage = root.querySelector('.qr2__stage');
  var KEY = root.dataset.klaviyoKey;
  var LIST = root.dataset.klaviyoList;
  var PRIVACY = root.dataset.privacyUrl;
  var TRUSTED = root.dataset.trustedWidget;
  var IMG = { hero: root.dataset.imgHero, viso: root.dataset.imgViso, corpo: root.dataset.imgCorpo, capelli: root.dataset.imgCapelli, regalo: root.dataset.imgRegalo };
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Soglie del mercato Italia: codice QUIZ da 50 €, spedizione gratuita da 89 € sul totale scontato (come la barra del carrello).
  var MIN_CODICE = 50;
  var SCONTO = 0.10;
  var SOGLIA_SPED = 89;

  var PRIMA = { viso: 'S', corpo: 'C1', capelli: 'K1', regalo: 'R0' };
  var MULTI = { V2: 2 };
  var ESCLUSIVA = { V2: 8 };
  var RASATURA = 7;
  var LINGUA = (root.dataset.locale || 'it').slice(0, 2).toLowerCase();

  // Testi nuovi della v2 per lingua. I testi validati (domande, rituali, schermate) stanno nei file dati di ogni lingua.
  var TESTI = {
    it: {
      destino: { viso: ' per il viso', corpo: ' per il corpo', capelli: ' per i capelli', regalo: ' da regalare' },
      indietro: 'Indietro',
      sceltaMulti: 'Puoi sceglierne fino a due.',
      contaScelte: function (n, max) { return n ? n + ' di ' + max + ' scelte' : 'Nessuna scelta'; },
      teaserKicker: 'Il tuo rituale è pronto',
      teaserGesti: function (n) { return n === 1 ? '1 prodotto, con il modo d\'uso' : n + ' prodotti, con il modo d\'uso di ognuno'; },
      nomeFacoltativo: 'Nome (facoltativo)',
      email: 'Email',
      privacy: 'Leggi l\'informativa sulla privacy.',
      riepilogo: 'In base alle tue risposte',
      scegliRituale: 'Scegli il rituale',
      gesto: function (n) { return 'Gesto ' + n; },
      essenziale: 'Essenziale',
      completo: 'Completo',
      prodotti: function (n) { return n === 1 ? '1 prodotto' : n + ' prodotti'; },
      aggiungi: 'Aggiungi',
      esaurito: 'Non disponibile',
      totale: 'Totale del rituale',
      conCodice: 'Con il tuo codice',
      codiceKicker: 'Il tuo codice',
      codiceTesto: '10% sul primo ordine da 50 € in su. Si applica da solo quando aggiungi i prodotti al carrello: non devi inserirlo.',
      codiceSotto: '10% sul primo ordine da 50 € in su. Si applica da solo appena il carrello arriva a 50 €.',
      ctaSconto: 'Aggiungi al carrello con il 10%',
      ctaAttesa: 'Aggiungo al carrello…',
      copia: 'Copia',
      copiato: 'Copiato',
      mancaCodice: function (x) { return 'Ti mancano ' + x + ' per attivare il tuo 10%.'; },
      codiceAttivo: 'il 10% è attivo.',
      giaNelCarrello: function (x) { return 'Nel carrello hai già ' + x + ' di prodotti: li contiamo nella barra qui sotto.'; },
      ctaCarrello: 'Il rituale è già nel carrello: vai al carrello',
      suggerisci: function (nome) { return 'Con ' + nome + ' lo raggiungi.'; },
      cta: 'Aggiungi il rituale al carrello',
      completa: 'Completa il rituale',
      anchePer: 'Anche per ',
      abbina: 'Si abbina bene',
      whatsapp: 'Hai un dubbio? Scrivici su WhatsApp',
      recap: {
        E: function (l) { return /anni|più/.test(l) ? l.replace('55 o più', '55 anni o più') : l + ' anni'; },
        V1: function (l, i) { return i === 4 ? null : 'Pelle ' + l.toLowerCase(); },
        V3: ['Poco sensibile', 'A volte sensibile', 'Pelle sensibile'],
        C3: ['Poco sensibile', 'A volte sensibile', 'Pelle sensibile'],
        C1: ['Pelle secca', 'Zone che si ispessiscono', 'Pelle un po\' spenta', 'Pelle meno tonica', 'Gambe pesanti'],
        K1: ['Cuoio capelluto senza fastidi', 'Cuoio capelluto che si unge', 'Cuoio capelluto che prude', 'Cuoio capelluto che si sfalda'],
        K2: ['Capelli più forti', 'Capelli più leggeri', 'Capelli più morbidi'],
        R0: ['Per lei', 'Per lui']
      }
    },
    en: {
      destino: { viso: ' for your face', corpo: ' for your body', capelli: ' for your hair', regalo: ' to give' },
      indietro: 'Back',
      sceltaMulti: 'You can choose up to two.',
      contaScelte: function (n, max) { return n ? n + ' of ' + max + ' selected' : 'Nothing selected'; },
      teaserKicker: 'Your ritual is ready',
      teaserGesti: function (n) { return n === 1 ? '1 product, with how to use it' : n + ' products, with how to use each one'; },
      nomeFacoltativo: 'Name (optional)',
      email: 'Email',
      privacy: 'Read our privacy policy.',
      riepilogo: 'Based on your answers',
      scegliRituale: 'Choose your ritual',
      gesto: function (n) { return 'Step ' + n; },
      essenziale: 'Essential',
      completo: 'Full',
      prodotti: function (n) { return n === 1 ? '1 product' : n + ' products'; },
      aggiungi: 'Add',
      esaurito: 'Unavailable',
      totale: 'Ritual total',
      conCodice: 'With your code',
      codiceKicker: 'Your code',
      codiceTesto: '10% off your first order of €50 or more. It applies automatically when you add the products to your cart: no need to enter it.',
      codiceSotto: '10% off your first order of €50 or more. It applies automatically as soon as your cart reaches €50.',
      ctaSconto: 'Add to cart with 10% off',
      ctaAttesa: 'Adding to cart…',
      copia: 'Copy',
      copiato: 'Copied',
      mancaCodice: function (x) { return 'Add ' + x + ' more to unlock your 10%.'; },
      codiceAttivo: 'your 10% is active.',
      giaNelCarrello: function (x) { return 'You already have ' + x + ' of products in your cart: we count them in the bar below.'; },
      ctaCarrello: 'The ritual is already in your cart: go to cart',
      suggerisci: function (nome) { return 'Adding ' + nome + ' gets you there.'; },
      cta: 'Add the ritual to cart',
      completa: 'Complete the ritual',
      anchePer: 'Also for ',
      abbina: 'Goes well with it',
      whatsapp: 'Any questions? Message us on WhatsApp',
      recap: {
        E: function (l) { return /years|over/i.test(l) ? l : l + ' years'; },
        V1: function (l, i) { return i === 4 ? null : l + ' skin'; },
        V3: ['Rarely sensitive', 'Sometimes sensitive', 'Sensitive skin'],
        C3: ['Rarely sensitive', 'Sometimes sensitive', 'Sensitive skin'],
        C1: ['Dry skin', 'Areas that thicken', 'Slightly dull skin', 'Less firm skin', 'Heavy legs'],
        K1: ['Comfortable scalp', 'Scalp that gets oily', 'Itchy scalp', 'Flaking scalp'],
        K2: ['Stronger hair', 'Lighter hair', 'Softer hair'],
        R0: ['For her', 'For him']
      }
    },
    de: {
      destino: { viso: ' für dein Gesicht', corpo: ' für deinen Körper', capelli: ' für deine Haare', regalo: ' zum Verschenken' },
      indietro: 'Zurück',
      sceltaMulti: 'Du kannst bis zu zwei auswählen.',
      contaScelte: function (n, max) { return n ? n + ' von ' + max + ' ausgewählt' : 'Nichts ausgewählt'; },
      teaserKicker: 'Dein Ritual ist bereit',
      teaserGesti: function (n) { return n === 1 ? '1 Produkt, mit Anwendungshinweisen' : n + ' Produkte, jeweils mit Anwendungshinweisen'; },
      nomeFacoltativo: 'Name (optional)',
      email: 'E-Mail',
      privacy: 'Lies unsere Datenschutzerklärung.',
      riepilogo: 'Basierend auf deinen Antworten',
      scegliRituale: 'Wähle dein Ritual',
      gesto: function (n) { return 'Schritt ' + n; },
      essenziale: 'Basis',
      completo: 'Vollständig',
      prodotti: function (n) { return n === 1 ? '1 Produkt' : n + ' Produkte'; },
      aggiungi: 'Hinzufügen',
      esaurito: 'Nicht verfügbar',
      totale: 'Summe des Rituals',
      conCodice: 'Mit deinem Code',
      codiceKicker: 'Dein Code',
      codiceTesto: '10 % auf deine erste Bestellung ab 50 €. Er wird automatisch angewendet, wenn du die Produkte in den Warenkorb legst: du musst ihn nicht eingeben.',
      codiceSotto: '10 % auf deine erste Bestellung ab 50 €. Er wird automatisch angewendet, sobald dein Warenkorb 50 € erreicht.',
      ctaSconto: 'Mit 10 % in den Warenkorb',
      ctaAttesa: 'Wird hinzugefügt…',
      copia: 'Kopieren',
      copiato: 'Kopiert',
      mancaCodice: function (x) { return 'Noch ' + x + ', dann sind deine 10 % aktiv.'; },
      codiceAttivo: 'deine 10 % sind aktiv.',
      giaNelCarrello: function (x) { return 'In deinem Warenkorb liegen schon Produkte für ' + x + ': wir zählen sie in der Leiste unten mit.'; },
      ctaCarrello: 'Das Ritual ist schon im Warenkorb: zum Warenkorb',
      suggerisci: function (nome) { return 'Mit ' + nome + ' erreichst du den Betrag.'; },
      cta: 'Ritual in den Warenkorb',
      completa: 'Ergänze dein Ritual',
      anchePer: 'Auch für ',
      abbina: 'Passt gut dazu',
      whatsapp: 'Noch Fragen? Schreib uns auf WhatsApp',
      recap: {
        E: function (l) { return /jahre|über|ab/i.test(l) ? l : l + ' Jahre'; },
        V1: function (l, i) { return i === 4 ? null : 'Haut: ' + l; },
        V3: ['Selten empfindlich', 'Manchmal empfindlich', 'Empfindliche Haut'],
        C3: ['Selten empfindlich', 'Manchmal empfindlich', 'Empfindliche Haut'],
        C1: ['Trockene Haut', 'Verdickte Stellen', 'Etwas fahle Haut', 'Weniger straffe Haut', 'Schwere Beine'],
        K1: ['Kopfhaut ohne Beschwerden', 'Schnell fettende Kopfhaut', 'Juckende Kopfhaut', 'Schuppende Kopfhaut'],
        K2: ['Kräftigeres Haar', 'Leichteres Haar', 'Weicheres Haar'],
        R0: ['Für sie', 'Für ihn']
      }
    }
  };
  var T = TESTI[LINGUA] || TESTI.it;
  var DESTINO = T.destino;
  var RECAP = T.recap;
  var RECAP_SALTA = { S: 1, F1: 1, F2: 1 };

  var percorso = null;
  var answers = {};
  var history = [];
  var current = null;
  var livelloScelto = null;
  var risultato = null;
  var alternativa = null;
  var attesaRisultato = null;

  /* ---------- utilità ---------- */

  function track(event, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event, quiz_name: 'trova_il_tuo_rituale', quiz_version: 'v2', quiz_language: (root.dataset.locale || 'it') };
    for (var k in extra) payload[k] = extra[k];
    window.dataLayer.push(payload);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function euro(n) {
    var fmt = window.shopSettings && window.shopSettings.moneyFormat;
    if (fmt && window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(Math.round(n * 100), fmt).replace(/<[^>]*>/g, '');
    }
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function img(src, alt, subito, w) {
    if (!src) return '';
    if (w) src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    return '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="' + (subito ? 'eager' : 'lazy') + '">';
  }

  function prima(key) {
    var v = answers[key];
    return Array.isArray(v) ? v[0] : v;
  }

  function contiene(gesti, alias) { return gesti.some(function (g) { return g[0] === alias; }); }

  function minuscola(s) { return s ? s.charAt(0).toLowerCase() + s.slice(1) : s; }

  /* ---------- prodotti dallo store ---------- */

  var LIVE = {};

  function P(alias) {
    var base = D.prodotti[alias];
    if (!base) return null;
    var out = {};
    for (var k in base) out[k] = base[k];
    var l = LIVE[alias];
    if (l) for (var j in l) out[j] = l[j];
    return out;
  }

  function disponibile(alias) {
    var p = P(alias);
    return !!p && p.disponibile !== false;
  }

  function caricaProdotto(alias) {
    if (LIVE[alias] || !D.prodotti[alias]) return Promise.resolve();
    var base = D.prodotti[alias];
    var handle = (base.url || '').split('/products/')[1];
    if (!handle) return Promise.resolve();
    return fetch('/products/' + handle.split(/[?#]/)[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.status === 404) { LIVE[alias] = { disponibile: false }; return null; }
        if (!r.ok) throw new Error('prodotto');
        return r.json();
      })
      .then(function (prod) {
        if (!prod) return;
        var v = prod.variants.filter(function (x) { return x.id === base.variante; })[0] ||
          prod.variants.filter(function (x) { return x.available; })[0] || prod.variants[0];
        var foto = prod.featured_image || (prod.images && prod.images[0]);
        LIVE[alias] = {
          variante: v.id,
          sku: v.sku || '',
          prezzo: v.price / 100,
          disponibile: !!v.available,
          url: ROOT.replace(/\/$/, '') + (base.url_locale || '/products/' + prod.handle),
          img: foto ? (foto.indexOf('//') === 0 ? 'https:' + foto : foto) : base.img
        };
      })
      .catch(function () { /* rete assente: restano i valori del JSON */ });
  }

  function caricaProdotti(aliases) {
    return Promise.all(aliases.filter(Boolean).map(caricaProdotto));
  }

  /* ---------- memoria: ricaricando la pagina o tornando indietro si riprende da dove si era ---------- */

  var MEM_CORSO = 'qr2_in_corso';
  var MEM_RISULTATO = 'qr2_risultato';
  var MEM_DURATA = 30 * 24 * 60 * 60 * 1000;

  function memLeggi(store, chiave) {
    try { var v = JSON.parse(window[store].getItem(chiave) || 'null'); return v && Date.now() - v.ts < MEM_DURATA ? v : null; } catch (e) { return null; }
  }
  function memScrivi(store, chiave, valore) {
    try { valore.ts = Date.now(); window[store].setItem(chiave, JSON.stringify(valore)); } catch (e) { /* navigazione privata */ }
  }
  function memCancella() {
    try { sessionStorage.removeItem(MEM_CORSO); localStorage.removeItem(MEM_RISULTATO); } catch (e) { /* niente */ }
  }
  function salvaCorso() {
    if (!percorso || !current || current === 'start') return;
    memScrivi('sessionStorage', MEM_CORSO, { percorso: percorso, answers: answers, history: history, current: current });
  }
  function salvaRisultato() {
    memScrivi('localStorage', MEM_RISULTATO, { percorso: percorso, answers: answers, livelloScelto: livelloScelto });
    try { sessionStorage.removeItem(MEM_CORSO); } catch (e) { /* niente */ }
  }

  /* ---------- navigazione ---------- */

  function next(step) {
    var a = answers;
    switch (step) {
      case 'S': return 'E';
      case 'E': return 'V1';
      case 'V1': return 'V3';
      case 'V3': return 'V2';
      case 'V2': return prima('V2') === RASATURA ? 'EMAIL' : 'F1';
      case 'C1':
        if (a.C1 === 0 || a.C1 === 1) return 'C2a';
        if (a.C1 === 3) return 'C2b';
        if (a.C1 === 4) return 'C2c';
        return 'C3';
      case 'C2a': case 'C2b': case 'C2c': return 'C3';
      case 'C3': return 'F1';
      case 'K1': return 'K2';
      case 'K2': return 'F1';
      case 'R0': return a.R0 === 1 ? 'EMAIL' : 'R1';
      case 'R1': return 'EMAIL';
      case 'F1': return 'F2';
    }
    return 'EMAIL';
  }

  function totaleStimato() {
    var a = answers;
    if (percorso === 'regalo') return a.R0 === 1 ? 1 : 2;
    if (percorso === 'viso') return prima('V2') === RASATURA ? 5 : 7;
    if (percorso === 'corpo') return a.C1 === 2 ? 4 : 5;
    if (percorso === 'capelli') return 4;
    return 5;
  }

  function altezzaHeader() {
    var h = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? r.height : 0;
  }

  function focusTitle() {
    var t = stage.querySelector('.qr2__title');
    if (t) { t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
    var top = root.getBoundingClientRect().top + window.scrollY - altezzaHeader() - 8;
    if (window.scrollY > top + 4 || window.scrollY < top - 400) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function go(step, push) {
    if (push && current) history.push(current);
    current = step;
    if (step !== 'EMAIL') attesaRisultato = null;
    root.setAttribute('data-schermata', step === 'start' ? 'ingresso' : step === 'RISULTATO' ? 'risultato' : 'domande');
    if (step === 'start') renderIngresso();
    else if (step === 'INTRO') renderIntro();
    else if (step === 'EMAIL') renderEmail();
    else renderDomanda(step);
    salvaCorso();
    focusTitle();
  }

  function back() {
    if (current === 'INTRO') { reset(); return; }
    if (!history.length) { go('INTRO', false); return; }
    current = history.pop();
    go(current, false);
  }

  function reset() {
    memCancella();
    percorso = null; answers = {}; history = []; livelloScelto = null; current = null;
    mostrato = null;
    risultato = null; alternativa = null; attesaRisultato = null;
    go('start', false);
  }

  /* ---------- schermate ---------- */

  function renderIngresso() {
    var schede = (I.schede || []).map(function (s) {
      return '<li><button type="button" class="qr2-card" data-percorso="' + esc(s[0]) + '">' +
        '<span class="qr2-card__media">' + img(IMG[s[0]], '', false, 800) + '</span>' +
        '<span class="qr2-card__body"><span class="qr2-card__title">' + esc(s[1]) + '</span>' +
        '<span class="qr2-card__text">' + esc(s[2]) + '</span>' +
        '<span class="qr2-card__foot">' + (s[3] ? '<span class="qr2-card__meta">' + esc(s[3]) + '</span>' : '') +
        '<span class="qr2-card__cta">' + esc(I.pulsante || 'Inizia') + '<span aria-hidden="true"> →</span></span></span></span></button></li>';
    }).join('');
    stage.innerHTML =
      '<div class="qr2-entry page-width">' +
      '<div class="qr2-entry__head"><div class="qr2-entry__text"><p class="qr2__kicker">' + esc(I.kicker) + '</p>' +
      '<h1 class="qr2__title h1">' + esc(I.titolo) + '</h1>' +
      '<p class="qr2__lead">' + esc(I.testo) + '</p>' +
      '<p class="qr2__help">' + esc(I.nota || S['Schermata iniziale · nota']) + '</p></div>' +
      (IMG.hero ? '<div class="qr2-entry__media">' + img(IMG.hero, '', true, 1200) + '</div>' : '') + '</div>' +
      '<ul class="qr2-cards">' + schede + '</ul></div>';
    stage.querySelectorAll('[data-percorso]').forEach(function (b) {
      b.addEventListener('click', function () {
        percorso = b.dataset.percorso;
        track('quiz_start', { quiz_path: percorso });
        go('INTRO', false);
      });
    });
  }

  function cornice(contenuto, opzioni) {
    opzioni = opzioni || {};
    var n = history.length + 1;
    var tot = Math.max(totaleStimato(), n);
    var prog = opzioni.progresso ?
      '<div class="qr2-progress" aria-hidden="true"><span class="qr2-progress__fill" style="width:' + Math.round(n / tot * 100) + '%"></span></div>' +
      '<p class="qr2-progress__text">' + esc((S['Avanzamento'] || 'Domanda {n} di {totale}').replace('{n}', n).replace('{totale}', tot)) + '</p>' : '';
    var media = IMG[percorso] || IMG.hero;
    return '<div class="qr2-split">' +
      (media ? '<div class="qr2-split__media">' + img(media, '', true, 1400) + '</div>' : '') +
      '<div class="qr2-split__content"><div class="qr2-top">' +
      '<button type="button" class="qr2-back" data-action="back"><span aria-hidden="true">←</span> ' + esc(T.indietro) + '</button>' + prog + '</div>' +
      contenuto + '</div></div>';
  }

  function renderIntro() {
    var it = (D.intro || {})[percorso] || ['', ''];
    stage.innerHTML = cornice('<p class="qr2__kicker">' + esc(I.titolo) + '</p>' +
      '<h2 class="qr2__title h1">' + esc(it[0]) + '</h2>' +
      '<p class="qr2__lead">' + esc(it[1]) + '</p>' +
      '<div class="qr2-actions"><button type="button" class="button qr2-actions__button" data-action="inizia">' + esc(D.intro_pulsante || 'Inizia') + '</button></div>');
    stage.querySelector('[data-action="back"]').addEventListener('click', back);
    stage.querySelector('[data-action="inizia"]').addEventListener('click', function () { go(PRIMA[percorso], false); });
  }

  function renderDomanda(key) {
    var q = D.domande[key];
    var multi = MULTI[key] || 0;
    var scelto = answers[key];
    var sel = multi ? (Array.isArray(scelto) ? scelto.slice() : []) : (typeof scelto === 'number' ? [scelto] : []);
    var ruolo = multi ? 'checkbox' : 'radio';
    var opts = q.risposte.map(function (r, i) {
      if (key === 'V2' && i === RASATURA && answers.S !== 1) return '';
      return '<li><button type="button" class="qr2-option qr2-option--' + ruolo + '" role="' + ruolo + '" data-i="' + i + '" aria-checked="' + (sel.indexOf(i) > -1) + '">' +
        '<span class="qr2-option__mark" aria-hidden="true"></span><span class="qr2-option__text">' +
        '<span class="qr2-option__label">' + esc(r[0]) + '</span>' +
        (r[1] ? '<span class="qr2-option__desc">' + esc(r[1]) + '</span>' : '') + '</span></button></li>';
    }).join('');
    var aiuto = q.aiuto && q.aiuto.indexOf('Compare solo') !== 0 && q.aiuto.indexOf('Dopo "') !== 0 ? q.aiuto : '';
    if (multi) aiuto = T.sceltaMulti;
    stage.innerHTML = cornice(
      '<h2 class="qr2__title h2" id="qr2-q-' + key + '">' + esc(q.testo) + '</h2>' +
      (aiuto ? '<p class="qr2__help">' + esc(aiuto) + '</p>' : '') +
      '<ul class="qr2-options" role="' + (multi ? 'group' : 'radiogroup') + '" aria-labelledby="qr2-q-' + key + '">' + opts + '</ul>' +
      (multi ? '<div class="qr2-bar"><p class="qr2__error" role="alert" hidden></p>' +
        '<p class="qr2-bar__count" aria-live="polite"></p>' +
        '<button type="button" class="button qr2-bar__button" data-action="avanti"' + (sel.length ? '' : ' disabled') + '>' + esc(S['Pulsante avanti'] || 'Avanti') + '</button></div>'
        : '<p class="qr2__error" role="alert" hidden></p>'),
      { progresso: true });
    stage.querySelector('[data-action="back"]').addEventListener('click', back);
    var bottoni = stage.querySelectorAll('.qr2-option');
    var avanti = stage.querySelector('[data-action="avanti"]');
    var errore = stage.querySelector('.qr2__error');
    var conta = stage.querySelector('.qr2-bar__count');
    var scelto1 = false;
    var aggiorna = function () {
      bottoni.forEach(function (o) { o.setAttribute('aria-checked', String(sel.indexOf(parseInt(o.dataset.i, 10)) > -1)); });
      if (avanti) avanti.disabled = !sel.length;
      if (conta) conta.textContent = T.contaScelte(sel.length, multi);
    };
    var conferma = function () {
      if (!sel.length) { errore.textContent = S['Errore nessuna risposta'] || ''; errore.hidden = false; return; }
      answers[key] = multi ? sel.slice() : sel[0];
      track('quiz_step', { quiz_step: key, quiz_answer: sel.map(function (i) { return q.risposte[i][0]; }).join(' + ') });
      go(next(key), true);
    };
    aggiorna();
    bottoni.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.dataset.i, 10);
        errore.hidden = true;
        if (!multi) {
          // scelta singola: toccare la risposta è già la conferma
          if (scelto1) return;
          scelto1 = true;
          sel = [i];
          aggiorna();
          setTimeout(conferma, 280);
          return;
        }
        var pos = sel.indexOf(i);
        if (pos > -1) sel.splice(pos, 1);
        else if (i === ESCLUSIVA[key]) sel = [i];
        else {
          sel = sel.filter(function (x) { return x !== ESCLUSIVA[key]; });
          if (sel.length >= multi) { errore.textContent = S['Errore troppe risposte'] || ''; errore.hidden = false; return; }
          sel.push(i);
        }
        aggiorna();
      });
    });
    if (avanti) avanti.addEventListener('click', conferma);
  }

  /* ---------- calcolo del rituale ---------- */

  function livelloBase() { return ['1', '2', '3'][answers.F1 || 0]; }
  function livello() { return livelloScelto || livelloBase(); }

  function ritualeId(L) {
    var a = answers;
    if (percorso === 'regalo') return a.R0 === 1 ? 'U-UOM' : ['R-ORO', 'R-SEN', 'R-FON'][a.R1 || 0];
    if (percorso === 'viso') {
      var eta = a.E || 0;
      switch (prima('V2')) {
        case 0: return (a.V1 === 2 && L !== '1') ? 'V-PUR-2' : 'V-ACN-' + L;
        case 1: return 'V-ROS-' + L;
        case 2: return 'V-SEC-' + L;
        case 3:
          if (L === '1') return 'V-AGE-1' + (eta >= 4 ? 'c' : eta === 3 ? 'b' : 'a');
          if (L === '2') return eta >= 4 ? 'V-AGE-2c' : 'V-AGE-2';
          return 'V-AGE-3';
        case 4: return 'V-TON-' + L;
        case 5: return 'V-MAC-' + L;
        case 7: return 'U-UOM';
        default: return (a.V3 === 2 ? 'V-SEN-' : 'V-IDR-') + L;
      }
    }
    if (percorso === 'corpo') {
      switch (a.C1) {
        case 0: return 'C-SEC-' + L;
        case 1: return 'C-PSO-' + L;
        case 2: return 'C-IDR-' + L;
        case 3: return L === '1' ? 'C-TON-1' + ['a', 'b', 'c'][a.C2b || 0] : 'C-TON-' + L;
        case 4: return 'C-GAM-' + L;
      }
    }
    if (percorso === 'capelli') {
      return ['K-RIG-', 'K-RIG-', 'K-SEC-', 'K-PSO-'][a.K1 || 0] + (L === '1' ? '1' : '2');
    }
    return 'V-IDR-2';
  }

  function gestiPersonalizzati(rid) {
    var a = answers;
    var g = D.rituali[rid].gesti.map(function (x) { return [x[0], x[1]]; });
    if (a.V3 === 2 || a.C3 === 2) {
      var sost = { venus: 'mask_len', sap_zolfo: 'sap_elicriso', sap_oliva: 'sap_lav' };
      g = g.map(function (x) {
        if (sost[x[0]] && !contiene(g, sost[x[0]])) return [sost[x[0]], x[1]];
        return x;
      }).filter(function (x) { return x[0] !== 'venus'; });
    }
    if (a.C2a === 0 && contiene(g, 'crema_corpo')) g = g.map(function (x) { return x[0] === 'crema_corpo' ? ['mani', x[1]] : x; });
    if (a.C2a === 3 && !contiene(g, 'apsor_sh') && !contiene(g, 'K_psoriasi')) g.push(['apsor_sh', 'a ogni lavaggio']);
    if (a.C2b === 1 && contiene(g, 'crema_smag')) g = g.map(function (x) { return x[0] === 'crema_smag' ? ['lift_seno', x[1]] : x; });
    if (a.C2c === 0) g.sort(function (x, y) { return (y[0] === 'hermes') - (x[0] === 'hermes'); });
    if (a.F2 === 2) g = g.filter(function (x) { return x[0] !== 'spray'; });
    return g;
  }

  function secondaAlias() {
    var a = answers;
    var seconda = percorso === 'viso' && Array.isArray(a.V2) && a.V2.length > 1 ? a.V2[1] : null;
    return seconda !== null && D.seconda ? { i: seconda, alias: D.seconda[seconda] } : null;
  }

  function calcola(L) {
    L = L || livello();
    var rid = ritualeId(L);
    if (!D.rituali[rid]) rid = 'V-IDR-2';
    var r = D.rituali[rid];
    var esiste = function (x) { return D.prodotti[x[0]]; };
    var tutti = gestiPersonalizzati(rid).filter(esiste);
    var sec = secondaAlias();
    // Il rituale deve arrivare al minimo del codice (50 €). Rinforzi possibili, in ordine:
    // i gesti del rituale completo dello stesso percorso, poi il prodotto "Usalo con". I kit non si spezzano.
    var rid2 = ritualeId(String(Math.min(3, parseInt(L, 10) + 1)));
    if (rid2 === rid || !D.rituali[rid2]) rid2 = null;
    var completo = rid2 ? gestiPersonalizzati(rid2).filter(esiste) : [];
    var usalo = (r.usalo || []).filter(function (u) { return D.prodotti[u]; }).map(function (u) { return [u, '']; });
    var daCaricare = tutti.concat(completo, usalo).map(function (x) { return x[0]; }).concat([sec && sec.alias]);
    return caricaProdotti(daCaricare).then(function () {
      var somma = function (g) { return g.reduce(function (s, x) { return s + P(x[0]).prezzo; }, 0); };
      var gesti = tutti.filter(function (x) { return disponibile(x[0]); });
      if (!gesti.length) gesti = tutti;
      var totale = somma(gesti);
      var rinforzato = false;
      if (totale < MIN_CODICE) {
        completo.concat(usalo).some(function (c) {
          if (totale >= MIN_CODICE) return true;
          if (c[0].indexOf('K_') === 0 || contiene(gesti, c[0]) || !disponibile(c[0])) return false;
          gesti.push(c);
          totale += P(c[0]).prezzo;
          rinforzato = true;
          return false;
        });
        if (totale < MIN_CODICE && rid2) {
          // nemmeno così: si propone direttamente il rituale completo
          var pieno = completo.filter(function (x) { return disponibile(x[0]); });
          if (pieno.length && somma(pieno) > totale) {
            rid = rid2; r = D.rituali[rid2]; L = String(parseInt(L, 10) + 1);
            gesti = pieno; totale = somma(pieno); rinforzato = false;
          }
        }
        if (rinforzato && completo.length) {
          // ordine dei gesti come nel rituale completo (detersione, spray, crema...)
          var pos = function (x) { var i = completo.map(function (c) { return c[0]; }).indexOf(x[0]); return i < 0 ? 99 : i; };
          gesti = gesti.map(function (x, i) { return [x, i]; })
            .sort(function (a, b) { return (pos(a[0]) - pos(b[0])) || (a[1] - b[1]); })
            .map(function (x) { return x[0]; });
        }
      }
      var gruppo = D.gruppi[r.gruppo] || { nome: '', codice: '' };
      var link = window.location.origin + '/cart/' + gesti.map(function (x) { return P(x[0]).variante + ':1'; }).join(',') + (gruppo.codice ? '?discount=' + gruppo.codice : '');
      var testoGesti = gesti.map(function (x, i) { return (i + 1) + '. ' + P(x[0]).nome + (x[1] ? ' (' + x[1] + ')' : ''); }).join(' · ');
      return { id: rid, livello: L, r: r, gesti: gesti, totale: totale, gruppoId: r.gruppo, gruppo: gruppo, link: link, testoGesti: testoGesti };
    });
  }

  function stessiProdotti(a, b) {
    if (!a || !b || a.gesti.length !== b.gesti.length) return false;
    return a.gesti.every(function (x) { return contiene(b.gesti, x[0]); });
  }

  function haAlternativa(res) { return livelloBase() === '1' && /-1[abc]?$/.test(res.id); }

  function risposteTesto() {
    var out = { percorso: percorso };
    Object.keys(answers).forEach(function (k) {
      var q = D.domande[k];
      var v = answers[k];
      if (q) out[k] = Array.isArray(v) ? v.map(function (i) { return q.risposte[i][0]; }).join(' + ') : q.risposte[v][0];
    });
    return out;
  }

  function riepilogo() {
    var voci = [];
    Object.keys(answers).forEach(function (k) {
      if (RECAP_SALTA[k] || !D.domande[k]) return;
      var v = Array.isArray(answers[k]) ? answers[k] : [answers[k]];
      v.forEach(function (i) {
        var label = D.domande[k].risposte[i][0];
        var m = RECAP[k];
        var testo = Array.isArray(m) ? m[i] : typeof m === 'function' ? m(label, i) : label;
        if (testo && !(k === 'V2' && i === ESCLUSIVA.V2)) voci.push(testo);
      });
    });
    return voci;
  }

  /* ---------- email con anteprima ---------- */

  function renderEmail() {
    attesaRisultato = attesaRisultato || calcola(livelloBase());
    var consenso = esc(S['Email · consenso (obbligatorio)']).replace(esc(T.privacy), '<a href="' + esc(PRIVACY) + '" target="_blank" rel="noopener">' + esc(T.privacy) + '</a>');
    stage.innerHTML = cornice(
      '<div class="qr2-teaser" aria-live="polite"><p class="qr2__kicker">' + esc(T.teaserKicker) + '</p>' +
      '<p class="qr2-teaser__title"><span class="qr2-skeleton"></span></p><div class="qr2-teaser__thumbs"></div></div>' +
      '<h2 class="qr2__title h2">' + esc(S['Email · titolo']) + '</h2>' +
      '<p class="qr2__lead">' + esc(S['Email · testo']) + '</p>' +
      '<form class="qr2-form" novalidate>' +
      '<label class="qr2-field"><span>' + esc(T.nomeFacoltativo) + '</span><input type="text" name="nome" autocomplete="given-name"></label>' +
      '<label class="qr2-field"><span>' + esc(T.email) + '</span><input type="email" name="email" autocomplete="email" inputmode="email" required></label>' +
      '<label class="qr2-consent"><input type="checkbox" name="consenso" required><span>' + consenso + '</span></label>' +
      '<p class="qr2__error" role="alert" hidden></p>' +
      '<button type="submit" class="button qr2-form__submit">' + esc(S['Email · pulsante']) + '</button></form>');
    stage.querySelector('[data-action="back"]').addEventListener('click', back);
    attesaRisultato.then(function (res) {
      var box = stage.querySelector('.qr2-teaser');
      if (!box) return;
      box.querySelector('.qr2-teaser__title').textContent = res.r.titolo + ' · ' + T.teaserGesti(res.gesti.length);
      box.querySelector('.qr2-teaser__thumbs').innerHTML = res.gesti.slice(0, 5).map(function (x) {
        return '<span class="qr2-teaser__thumb">' + img(P(x[0]).img, '', true, 200) + '</span>';
      }).join('');
    });
    var form = stage.querySelector('form');
    var err = stage.querySelector('.qr2__error');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = S['Errore email']; err.hidden = false; form.email.focus(); return; }
      if (!form.consenso.checked) { err.textContent = S['Errore consenso']; err.hidden = false; return; }
      err.hidden = true;
      var nome = form.nome.value.trim();
      var bottone = form.querySelector('button[type="submit"]');
      bottone.disabled = true;
      bottone.classList.add('loading');
      bottone.textContent = S['Attesa'] || '…';
      attesaRisultato.then(function (res) {
        return inviaKlaviyo(email, nome, res).then(function () {
          track('quiz_complete', { quiz_path: percorso, quiz_ritual: res.id, quiz_group: res.gruppoId });
          risultato = res;
          if (res.gruppo.codice) fetch(ROOT.replace(/\/$/, '') + '/discount/' + encodeURIComponent(res.gruppo.codice), { credentials: 'same-origin' }).catch(function () {});
          if (haAlternativa(res)) calcola('2').then(function (alt) { alternativa = alt; aggiornaToggle(); });
          current = 'RISULTATO';
          root.setAttribute('data-schermata', 'risultato');
          salvaRisultato();
          renderRisultato(res);
        });
      });
    });
  }

  function klaviyoPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KEY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
      body: JSON.stringify(body)
    });
  }

  function inviaKlaviyo(email, nome, res) {
    var props = {
      quiz_gruppo: res.gruppoId, quiz_codice: res.gruppo.codice, quiz_rituale_id: res.id, quiz_rituale_titolo: res.r.titolo,
      quiz_rituale_gesti: res.testoGesti, quiz_link_rituale: res.link, quiz_data: new Date().toISOString(), quiz_lingua: LINGUA, quiz_risposte: risposteTesto()
    };
    var profileAttrs = { email: email, properties: props };
    if (nome) profileAttrs.first_name = nome;
    var attesa = new Promise(function (r) { setTimeout(r, 900); });
    var chiamate = klaviyoPost('profiles', { data: { type: 'profile', attributes: profileAttrs } })
      .then(function () {
        return klaviyoPost('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Questionario rituale',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
          relationships: { list: { data: { type: 'list', id: LIST } } } } });
      })
      .then(function () {
        return klaviyoPost('events', { data: { type: 'event', attributes: { properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Questionario completato' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } } } } });
      })
      .catch(function (e) { if (window.console) console.warn('Questionario rituale: invio a Klaviyo non riuscito', e); });
    return Promise.all([attesa, chiamate]);
  }

  /* ---------- risultato ---------- */

  function schedaProdotto(alias, etichetta, quando) {
    var p = P(alias);
    var ok = p.disponibile !== false;
    return '<li class="qr2-product">' +
      '<a class="qr2-product__media" href="' + esc(p.url) + '">' + img(p.img, p.nome, false, 600) +
      (etichetta ? '<span class="qr2-product__badge">' + esc(etichetta) + '</span>' : '') + '</a>' +
      '<div class="qr2-product__head">' +
      (quando ? '<span class="qr2-product__when">' + esc(quando) + '</span>' : '') +
      '<a class="qr2-product__name" href="' + esc(p.url) + '">' + esc(p.nome) + '</a></div>' +
      '<div class="qr2-product__body">' +
      '<p class="qr2-product__why">' + esc(p.perche) + '</p>' +
      (TRUSTED && p.sku ? '<div class="qr2-product__reviews"><etrusted-widget data-etrusted-widget-id="' + esc(TRUSTED) + '" data-sku="' + esc(p.sku) + '"></etrusted-widget></div>' : '') +
      '<div class="qr2-product__buy"><span class="qr2-product__price">' + euro(p.prezzo) + '</span>' +
      (ok ? '<add-to-cart class="button button--small qr2-product__add" data-variant-id="' + esc(p.variante) + '" role="button" tabindex="0">' + esc(T.aggiungi) + '</add-to-cart>'
        : '<span class="qr2-product__soldout">' + esc(T.esaurito) + '</span>') +
      '</div></div></li>';
  }

  /* ---------- carrello: stessa barra, stesse soglie e stessi testi del carrello laterale ---------- */

  var REGOLE = (function () {
    var p = (root.dataset.cartRules || '').split('|');
    return { attivo: p[0] === '1', ship: (parseInt(p[2], 10) || 0) / 100, gift: (parseInt(p[3], 10) || 0) / 100, ordine: p[4] || 'ship-gift' };
  })();
  var TXT_CARRELLO = (function () {
    var el = document.getElementById('QuizRitualeCarrelloTesti');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  })();
  var CARRELLO = { subtotale: 0, varianti: {} };
  var mostrato = null;

  function leggiCarrello() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        CARRELLO.subtotale = (c.items_subtotal_price || 0) / 100;
        CARRELLO.varianti = {};
        (c.items || []).forEach(function (i) { CARRELLO.varianti[i.variant_id] = true; });
      })
      .catch(function () { /* resta l'ultimo valore letto */ });
  }

  function mancanti(res) {
    return res.gesti.filter(function (x) { return disponibile(x[0]) && !CARRELLO.varianti[P(x[0]).variante]; });
  }

  // Proiezione del carrello dopo "Aggiungi il rituale": prodotti già presenti più quelli del rituale che mancano.
  // Il minimo del codice vale sul subtotale, spedizione e omaggio sul totale scontato (come cart.total_price).
  function calcoloSoglie(res) {
    var nuovi = mancanti(res).reduce(function (t, x) { return t + P(x[0]).prezzo; }, 0);
    var base = CARRELLO.subtotale + nuovi;
    var attivo = base >= MIN_CODICE;
    return {
      attivo: attivo,
      base: base,
      scontato: attivo ? base * (1 - SCONTO) : base,
      mancaCodice: Math.max(0, MIN_CODICE - base),
      ritualeScontato: attivo ? res.totale * (1 - SCONTO) : res.totale,
      nuovi: nuovi
    };
  }

  function euroTondo(n) { return euro(n).replace(/[,.]00(?=\D*$)/, ''); }

  // Replica di snippets/webgas-cart-progress.liquid: fette uguali, un pallino per traguardo al centro della sua fetta.
  function barraCarrello(totale) {
    if (!REGOLE.attivo || !REGOLE.ship) return '';
    var tiers = [];
    if (REGOLE.ordine === 'gift-ship') {
      if (REGOLE.gift) tiers.push(['gift', REGOLE.gift]);
      if (!REGOLE.gift || totale >= REGOLE.gift) tiers.push(['ship', REGOLE.ship]);
    } else {
      tiers.push(['ship', REGOLE.ship]);
      if (REGOLE.gift) tiers.push(['gift', REGOLE.gift]);
    }
    var raggiunti = 0, basso = 0, alto = 0, prossimo = null, manca = 0;
    tiers.forEach(function (t) {
      if (totale >= t[1] - 0.004) { raggiunti++; basso = t[1]; }
      else if (!prossimo) { prossimo = t[0]; manca = t[1] - totale; alto = t[1]; }
    });
    var tutti = raggiunti === tiers.length;
    var pct = 100;
    if (!tutti) {
      var fetta = 1 / tiers.length;
      var dentro = alto > basso ? Math.min(1, Math.max(0, (totale - basso) / (alto - basso))) : 0;
      var frazione = tiers.length === 1 ? dentro : raggiunti === 0 ? dentro * fetta * 0.5 : (raggiunti - 0.5) * fetta + dentro * fetta;
      pct = Math.round(frazione * 10000) / 100;
    }
    var importo = '<price-money class="price"><bdi>' + esc(euro(manca)) + '</bdi></price-money>';
    var msg = tutti ? esc(TXT_CARRELLO.giftReached || '') :
      String(prossimo === 'ship' ? TXT_CARRELLO.toShipping || '' : TXT_CARRELLO.toGift || '').replace('[amount]', importo);
    return '<div class="free-shipping wg-progress qr2-progress-cart' + (tutti ? ' wg-progress--complete' : '') + (tiers.length === 1 ? ' wg-progress--single' : '') + '">' +
      '<p class="wg-progress__message' + (tutti ? ' wg-progress__message--success' : '') + '">' + msg + '</p>' +
      '<div class="wg-progress__track" style="--progress: ' + pct + '%;" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><span class="wg-progress__fill"></span></div>' +
      '<ul class="wg-progress__tiers list-unstyled" aria-hidden="true">' + tiers.map(function (t) {
        var ok = totale >= t[1] - 0.004;
        return '<li class="wg-progress__tier' + (ok ? ' is-reached' : '') + '"><span class="wg-progress__tier-dot">' +
          (ok ? '<svg class="wg-progress__tier-check" viewBox="0 0 12 12" focusable="false" aria-hidden="true"><path d="M2.5 6.2 4.7 8.5 9.5 3.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' : '') +
          '</span><span class="wg-progress__tier-text"><span class="wg-progress__tier-label">' + esc(t[0] === 'ship' ? TXT_CARRELLO.tierShipping : TXT_CARRELLO.tierGift) + '</span>' +
          '<span class="wg-progress__tier-amount">' + esc(euroTondo(t[1])) + '</span></span></li>';
      }).join('') + '</ul></div>';
  }

  function sommario(res) {
    var s = calcoloSoglie(res);
    var codice = res.gruppo.codice;
    var stato;
    if (s.attivo) stato = esc(T.conCodice) + ' ' + esc(codice) + ': ' + esc(T.codiceAttivo);
    else {
      stato = esc(T.mancaCodice(euro(s.mancaCodice)));
      var usalo = res.r.usalo && res.r.usalo[0];
      if (usalo && D.prodotti[usalo] && disponibile(usalo) && !contiene(res.gesti, usalo) && s.base + P(usalo).prezzo >= MIN_CODICE) stato += ' ' + esc(T.suggerisci(P(usalo).nome));
    }
    var tuttoNelCarrello = !mancanti(res).length;
    return '<section class="qr2-summary" aria-label="' + esc(T.totale) + '">' +
      '<div class="qr2-summary__totals"><p class="qr2__kicker">' + esc(T.totale) + ' · ' + esc(T.prodotti(res.gesti.length)) + '</p>' +
      '<p class="qr2-summary__price">' + (s.attivo ? '<s>' + euro(res.totale) + '</s> <strong>' + euro(s.ritualeScontato) + '</strong>' : '<strong>' + euro(res.totale) + '</strong>') + '</p>' +
      '<p class="qr2-summary__note">' + stato + '</p>' +
      (CARRELLO.subtotale > 0 ? '<p class="qr2-summary__note qr2-summary__note--muted">' + esc(T.giaNelCarrello(euro(CARRELLO.subtotale))) + '</p>' : '') +
      barraCarrello(s.scontato) + '</div>' +
      (codice ? '<div class="qr2-summary__code"><p class="qr2__kicker">' + esc(T.codiceKicker) + '</p>' +
        '<div class="qr2-code"><span class="qr2-code__value">' + esc(codice) + '</span>' +
        '<button type="button" class="qr2-code__copy" data-action="copia" data-codice="' + esc(codice) + '">' + esc(T.copia) + '</button></div>' +
        '<p class="qr2-summary__note">' + esc(s.attivo ? T.codiceTesto : T.codiceSotto) + '</p></div>' : '') +
      '<div class="qr2-summary__cta"><button type="button" class="button qr2-cta" data-action="cart">' +
      esc(tuttoNelCarrello ? T.ctaCarrello : s.attivo && codice ? T.ctaSconto : T.cta) + '</button></div>' +
      '</section>';
  }

  function collegaSommario(res) {
    stage.querySelectorAll('[data-action="cart"]').forEach(function (b) {
      b.addEventListener('click', function (e) { aggiungiAlCarrello(res, e.currentTarget); });
    });
    var copia = stage.querySelector('[data-action="copia"]');
    if (copia) copia.addEventListener('click', function () {
      var fatto = function () { copia.textContent = T.copiato; setTimeout(function () { copia.textContent = T.copia; }, 2000); };
      if (navigator.clipboard) navigator.clipboard.writeText(copia.dataset.codice).then(fatto, fatto); else fatto();
    });
  }

  function aggiornaSommario() {
    if (!mostrato || current !== 'RISULTATO') return;
    var vecchio = stage.querySelector('.qr2-summary');
    if (vecchio) vecchio.outerHTML = sommario(mostrato);
    var breve = stage.querySelector('.qr2-sticky__price');
    if (breve) breve.innerHTML = sommarioBreve(mostrato);
    var ctaFissa = stage.querySelector('.qr2-sticky .qr2-cta');
    var ctaNuova = stage.querySelector('.qr2-summary .qr2-cta');
    if (ctaFissa && ctaNuova) {
      var copiaCta = ctaFissa.cloneNode(false);
      copiaCta.textContent = ctaNuova.textContent;
      ctaFissa.replaceWith(copiaCta);
    }
    collegaSommario(mostrato);
    barraFissa();
  }

  // Il carrello cambia dal carrello laterale o dai pulsanti "Aggiungi": la barra si riallinea.
  document.addEventListener('ajaxProduct:added', function () { leggiCarrello().then(aggiornaSommario); });
  window.addEventListener('focus', function () { if (mostrato) leggiCarrello().then(aggiornaSommario); });
  var miniCart = document.querySelector('mini-cart');
  if (miniCart && 'MutationObserver' in window) {
    var attesaMini = null;
    new MutationObserver(function () {
      clearTimeout(attesaMini);
      attesaMini = setTimeout(function () { if (mostrato) leggiCarrello().then(aggiornaSommario); }, 400);
    }).observe(miniCart, { childList: true, subtree: true });
  }

  function toggleHtml(res) {
    if (!haAlternativa(risultato)) return '';
    if (alternativa && stessiProdotti(risultato, alternativa)) return '';
    var base = risultato.livello === '1' ? risultato : null;
    var uno = livello() === '1' ? res : base;
    var due = livello() === '2' ? res : alternativa;
    var voce = function (L, r, nome) {
      var attivo = livello() === L;
      return '<button type="button" class="qr2-toggle__item" role="radio" aria-checked="' + attivo + '" data-livello="' + L + '">' +
        '<span class="qr2-toggle__name">' + esc(nome) + '</span>' +
        '<span class="qr2-toggle__meta">' + (r ? esc(T.prodotti(r.gesti.length)) + ' · ' + euro(r.totale) : '…') + '</span></button>';
    };
    return '<div class="qr2-toggle" role="radiogroup" aria-label="' + esc(T.scegliRituale) + '">' + voce('1', uno, T.essenziale) + voce('2', due, T.completo) + '</div>';
  }

  function aggiornaToggle() {
    var t = stage.querySelector('.qr2-toggle-slot');
    if (!t || !risultato) return;
    t.innerHTML = toggleHtml(livello() === '1' ? risultato : alternativa || risultato);
    collegaToggle();
  }

  function collegaToggle() {
    stage.querySelectorAll('.qr2-toggle__item').forEach(function (b) {
      b.addEventListener('click', function () {
        var L = b.dataset.livello;
        if (L === livello()) return;
        livelloScelto = L === livelloBase() ? null : L;
        var res = L === '1' ? risultato : alternativa;
        track('quiz_level_switch', { quiz_level: L });
        salvaRisultato();
        if (res) renderRisultato(res, true);
        else calcola(L).then(function (r) { alternativa = r; renderRisultato(r, true); });
      });
    });
  }

  function renderRisultato(res, mantieniScroll) {
    var r = res.r;
    var a = answers;
    var prodotti = res.gesti.map(function (x, i) { return schedaProdotto(x[0], T.gesto(i + 1), x[1]); }).join('');
    var note = '';
    var haKit = res.gesti.some(function (x) { return x[0].indexOf('K_') === 0; });
    if (a.F2 === 2) note += '<p class="qr2-note">' + esc(haKit ? S['Risultato · nota Tanica (kit con spray)'] : S['Risultato · nota Tanica (rituale senza spray)']) + '</p>';
    if (a.F2 === 1) note += '<p class="qr2-note">' + esc(S['Risultato · nota spray']) + '</p>';
    var mese = new Date().getMonth();
    if (res.id.indexOf('V-MAC') === 0 && (mese >= 9 || mese <= 2) && contiene(res.gesti, 'solaris50')) note += '<p class="qr2-note">' + esc(S['Risultato · nota protezione solare (ottobre-marzo)']) + '</p>';

    var extra = [];
    var sec = secondaAlias();
    if (sec && D.prodotti[sec.alias] && disponibile(sec.alias) && !contiene(res.gesti, sec.alias)) {
      extra.push(schedaProdotto(sec.alias, '', T.anchePer + minuscola(D.domande.V2.risposte[sec.i][0])));
    }
    var usalo = r.usalo && r.usalo[0];
    if (usalo && D.prodotti[usalo] && disponibile(usalo) && !contiene(res.gesti, usalo) && (!sec || usalo !== sec.alias)) {
      extra.push(schedaProdotto(usalo, '', T.abbina));
    }
    var voci = riepilogo();
    var ws = root.dataset.whatsapp;

    stage.innerHTML =
      '<div class="qr2-result">' +
      '<header class="qr2-result__head page-width"><div class="qr2-result__intro">' +
      '<p class="qr2__kicker">' + esc(S['Risultato · intestazione'] + (DESTINO[percorso] || '')) + '</p>' +
      '<h2 class="qr2__title h1">' + esc(r.titolo) + '</h2>' +
      (voci.length ? '<div class="qr2-recap"><span class="qr2-recap__label">' + esc(T.riepilogo) + '</span><ul class="qr2-recap__list">' +
        voci.map(function (v) { return '<li>' + esc(v) + '</li>'; }).join('') + '</ul></div>' : '') +
      '<p class="qr2__lead">' + esc(r.storia) + '</p>' + note +
      '<button type="button" class="qr2-link qr2-result__restart" data-action="restart">' + esc(S['Risultato · rifai']) + '</button></div></header>' +
      '<div class="page-width"><div class="qr2-toggle-slot">' + toggleHtml(res) + '</div>' +
      '<ul class="qr2-products" id="qr2-prodotti">' + prodotti + '</ul>' +
      sommario(res) +
      (extra.length ? '<section class="qr2-more"><h3 class="qr2-more__title h3">' + esc(T.completa) + '</h3><ul class="qr2-products qr2-products--more">' + extra.join('') + '</ul></section>' : '') +
      '<section class="qr2-info"><div class="qr2-info__text"><p class="qr2__kicker">' + esc(S['Risultato · riquadro Acqua di Nitrodi · titolo']) + '</p>' +
      '<p>' + esc(S['Risultato · riquadro Acqua di Nitrodi · testo']) + '</p></div></section>' +
      '<div class="qr2-foot"><p class="qr2__help">' + esc(S['Risultato · spedizione · nota fissa']) + '</p>' +
      (ws ? '<a class="qr2-link" href="' + esc(ws) + '" target="_blank" rel="noopener">' + esc(T.whatsapp) + '</a>' : '') +
      '<button type="button" class="qr2-link" data-action="restart">' + esc(S['Risultato · rifai']) + '</button></div></div>' +
      '<div class="qr2-sticky" hidden><div class="qr2-sticky__price">' + sommarioBreve(res) + '</div>' +
      '<button type="button" class="button qr2-cta" data-action="cart">' + esc(calcoloSoglie(res).attivo && res.gruppo.codice ? T.ctaSconto : T.cta) + '</button></div>' +
      '</div>';

    mostrato = res;
    collegaSommario(res);
    stage.querySelectorAll('[data-action="restart"]').forEach(function (b) { b.addEventListener('click', reset); });
    collegaToggle();
    leggiCarrello().then(aggiornaSommario);
    stage.querySelectorAll('add-to-cart').forEach(function (b) {
      b.addEventListener('click', function () {
        track('quiz_add_single', { quiz_ritual: res.id, quiz_group: res.gruppoId });
      });
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); } });
    });
    barraFissa();
    if (!mantieniScroll) focusTitle();
  }

  function sommarioBreve(res) {
    var s = calcoloSoglie(res);
    return '<span class="qr2-sticky__label">' + esc(T.prodotti(res.gesti.length)) + '</span>' +
      '<span class="qr2-sticky__total">' + euro(s.ritualeScontato) + '</span>';
  }

  var osservatore = null;
  function barraFissa() {
    var barra = stage.querySelector('.qr2-sticky');
    var summary = stage.querySelector('.qr2-summary');
    var lista = stage.querySelector('#qr2-prodotti');
    if (!barra || !summary || !lista || !('IntersectionObserver' in window)) return;
    if (osservatore) osservatore.disconnect();
    var vistaSummary = false;
    var oltreLista = false;
    var aggiorna = function () { barra.hidden = vistaSummary || !oltreLista; };
    osservatore = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === summary) vistaSummary = e.isIntersecting;
        if (e.target === lista) oltreLista = e.isIntersecting || e.boundingClientRect.top < 0;
      });
      aggiorna();
    });
    osservatore.observe(summary);
    osservatore.observe(lista);
  }

  function aggiungiAlCarrello(res, btn) {
    stage.querySelectorAll('[data-action="cart"]').forEach(function (b) {
      b.disabled = true;
      b.dataset.testo = b.dataset.testo || b.textContent;
      b.textContent = T.ctaAttesa;
    });
    track('quiz_add_to_cart', { quiz_ritual: res.id, quiz_group: res.gruppoId, value: res.totale });
    var items = mancanti(res).map(function (x) { return { id: P(x[0]).variante, quantity: 1 }; });
    var invio = items.length ? fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
    }) : Promise.resolve({ ok: true });
    invio.then(function (r) {
      if (!r.ok) throw new Error('cart');
      var carrello = ROOT + 'cart';
      window.location.href = res.gruppo.codice ? ROOT.replace(/\/$/, '') + '/discount/' + encodeURIComponent(res.gruppo.codice) + '?redirect=' + encodeURIComponent(carrello) : carrello;
    }).catch(function () { window.location.href = res.link; });
  }

  // Tornando dal carrello con Indietro il browser ripristina la pagina com'era: riattiva i pulsanti.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    stage.querySelectorAll('[data-action="cart"]').forEach(function (b) {
      b.disabled = false;
      if (b.dataset.testo) b.textContent = b.dataset.testo;
    });
  });

  function riprendi() {
    var fatto = memLeggi('localStorage', MEM_RISULTATO);
    if (fatto && D.intro[fatto.percorso]) {
      percorso = fatto.percorso; answers = fatto.answers || {}; livelloScelto = fatto.livelloScelto || null;
      current = 'RISULTATO';
      root.setAttribute('data-schermata', 'risultato');
      stage.innerHTML = '<div class="page-width qr2-loading"><p class="qr2__lead">' + esc(S['Attesa'] || '') + '</p></div>';
      return calcola(livelloBase()).then(function (base) {
        risultato = base;
        if (base.gruppo.codice) fetch(ROOT.replace(/\/$/, '') + '/discount/' + encodeURIComponent(base.gruppo.codice), { credentials: 'same-origin' }).catch(function () {});
        var alt = haAlternativa(base) ? calcola('2') : Promise.resolve(null);
        return alt.then(function (a2) {
          alternativa = a2;
          renderRisultato(livello() === '2' && a2 ? a2 : base, true);
        });
      }).then(function () { return true; }, function () { memCancella(); return false; });
    }
    var corso = memLeggi('sessionStorage', MEM_CORSO);
    if (corso && D.intro[corso.percorso] && corso.current) {
      percorso = corso.percorso; answers = corso.answers || {}; history = corso.history || [];
      go(corso.current, false);
      return Promise.resolve(true);
    }
    return Promise.resolve(false);
  }

  riprendi().then(function (ok) { if (!ok) go('start', false); });
})();
